// extracted by mini-css-extract-plugin
export default {"formContents":"invite_formContents__m0K4b","emailInput":"invite_emailInput__oxm-Q"};